import { I18n } from 'aws-amplify'

const Strings = () => ({
  manageInventoryTransfers: I18n.get('Manage Inventory Transfers'),
  createInventoryTransfer: I18n.get('Transfer'),
  createFormHeader: I18n.get('Create New Transfer'),
  updateFormHeader: I18n.get('Update Existing Transfer'),
  noInventoryTransfers: I18n.get('No inventory transfers'),
  saveInventoryTransfer: I18n.get('Save Transfer'),
  selectDefault: I18n.get('Please Select'),
  inventoryTransfer: I18n.get('Inventory Transfer'),
  transfer: I18n.get('Transfer'),
  inventory: I18n.get('Inventory'),
  produce: I18n.get('Produce'),
  variety: I18n.get('Variety'),
  grade: I18n.get('Grade'),
  fromStorageFacility: I18n.get('Origin'),
  toStorageFacility: I18n.get('Destination'),
  shippingMethod: I18n.get('Shipping Method'),
  totalWeight: I18n.get('Total Weight'),
  status: I18n.get('Status'),
  shippedDate: I18n.get('Date Shipped'),
  deliveredDate: I18n.get('Date Delivered'),
  from: I18n.get('Origin'),
  to: I18n.get('Destination'),
  weight: I18n.get('Weight'),
  kilograms: I18n.get('kg'),
  pending: I18n.get('Pending'),
  shipped: I18n.get('Shipped'),
  delivered: I18n.get('Delivered'),
  canceled: I18n.get('Canceled')
})

export default Strings
